<template>
	<div>
		
		<div class="pageFrom  animate__animated  ">
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
				<span>地址管理</span>
			</div>
			
			<div class="shaixuanFrom f-bct">
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="consignee" :placeholder="$t('point.t2')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="mobile" :placeholder="$t('point.t3')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="address" :placeholder="$t('point.t4')"></el-input>
				</div>
				<div class="action-bar1">
					<el-button type="primary" class="submit-btn" @click="warehouselist">{{$t('point.t5')}}</el-button>
				</div>
			</div>
			
			<!-- 暂无 -->
			<div class="zwBox" v-if="!cangMsg.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			
			<div class="cangList f-bct">
				<div class="info-card" v-for="(item,index) in cangMsg">
					<el-image class="card-icon" :src="require('@/static/add2/39.png')"></el-image>
					<div class="card-body">
						<div class="card-name f-bct">
							<div class="name f-ct" v-if="item.addressType==1">
								<span class="t1">{{item.consignee}}</span>
								<span class="t3">送货上门</span>
							</div>
							<div class="name f-ct" v-if="item.addressType==2">
								<span class="t1">{{item.selfPickupSite.name}}</span>
								<span class="t2">自提</span>
							</div>
							<div class="f-ct">
								<div class="copy f-ct" @click="link('/userPageLab/myAddrMsg',{id:item.id,shua:true})">
									<el-image :src="require('@/static/add2/41.png')"></el-image>
									<span>编辑</span>
								</div>
								<div class="del f-ct" @click="delAddr(item,index)">
									<el-image :src="require('@/static/add2/42.png')"></el-image>
									<span>删除</span>
								</div>
							</div>
						</div>
						<div class="card-contact" v-if="item.addressType==1">
							<span>{{item.mobile}}</span>
						</div>
						<div class="card-contact" v-if="item.addressType==2">
							<span>{{item.consignee}}</span>
							<span>{{item.mobile}}</span>
						</div>
						<div class="card-addr"><span class="addr-blue">{{item.countryName||'--'}}</span>{{item.provinceName}}{{item.cityName}}{{item.address}}</div>
					</div>
				</div>
			</div>
			
		</div>
		
		<!-- 底部按钮区 -->
		<div class="dialog-footer  animate__animated  ">
			<button class="btn-confirm" @click="link('/userPageLab/myAddrMsg',{shua:true})">新增收件人</button>
		</div>

		<!-- ====== 删除确认弹窗 ====== -->
		<el-dialog
			:visible.sync="delDialogVisible"
			width="4.2rem"
			:show-close="true"
			:close-on-click-modal="true">
			<div slot="title" class="del-dialog-header">
				<h3 class="del-dialog-title">删除确认</h3>
			</div>
			<div class="del-dialog-body">
				<p class="del-dialog-text">是否确认删除该地址？</p>
			</div>
			<div slot="footer" class="del-dialog-footer">
				<div class="del-btn del-btn-cancel" @click="delDialogVisible = false">取消</div>
				<div class="del-btn del-btn-confirm" @click="confirmDelete">确认</div>
			</div>
		</el-dialog>

	</div>
</template>
<script>
import { memberAddresslist, memberAddressDelete } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			// 搜索
			consignee:'',
			mobile:'',
			address:'',
			// 列表
			cangMsg:[],
			selIdx:0,
			// 删除弹窗
			delDialogVisible: false,
			delItem: null,
			delIndex: -1,
		}
	},
	mounted() {
		this.warehouselist()
	},
	methods:{
		// 选择并返回
		submitOrder(){
			var item = this.cangMsg[this.selIdx]
			this.$bus.$emit('cangMsgGet', item)
			this.back()
		},
		// 地址列表
		async warehouselist(){
			var data = {}
			const res = await memberAddresslist(data)
			if(res.code==200){
				this.cangMsg = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 点击删除，弹出确认框
		delAddr(item, index) {
			this.delItem = item
			this.delIndex = index
			this.delDialogVisible = true
		},
		// 确认删除
		async confirmDelete() {
			if (!this.delItem) return
			const res = await memberAddressDelete({ id: this.delItem.id })
			if (res.code == 200) {
				this.Tips(res.msg || '删除成功')
				this.delDialogVisible = false
				this.delItem = null
				this.delIndex = -1
				this.warehouselist()
			} else {
				this.Tips(res.msg || '删除失败', 'error')
			}
		},
	},
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #999999;
$text-muted: #C6C6C6;
$border-color: #D9D9D9;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;
$cargo-bg: #FAFCFE;
$info-bg: #FAFAFA;
$thumb-bg: #E7F6FF;
$radius-sm: 0.04rem;
$radius-md: 0.08rem;
$radius-lg: 0.12rem;

$font-lg: 0.20rem;
$font-md: 0.16rem;
$font-sm: 0.14rem;
$font-xs: 0.13rem;

$input-height: 0.50rem;
$gap-section: 0.32rem;
$gap-form: 24px;
$gap-upload: 0.14rem;
$sel-gap: 24px; // 选项间距	

/* ========== 通用区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		// flex-shrink: 0;
		display: block;
	}

	span {
		font-size: $font-lg;
		font-weight: 500;
		color: $text-dark;
	}
}
.pageFrom{
	width: 100%;
	background: #fff;
	border-radius: 10px;
	padding: 24px 32px;
	margin-top: 24px;
	padding-bottom: 40px;
	
}
/* ========== 操作按钮区 ========== */
.action-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.30rem;
	padding-top: 0.24rem;
	.submit-btn {
		width: 1.84rem;
		height: 0.60rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.submit-btn {
		width: 1.16rem;
		height: 0.46rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

/* ========== 信息卡片 ========== */
.cangList{
	
}

.info-card {
	width: 758px;
	background: #f9f9f9;
	cursor: pointer;
	border-radius: 12px;
	padding: 24px 32px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	margin-top: 0.16rem;
	transition:  0.25s ;

	.card-icon {
		width: 0.20rem;
		height: 0.20rem;
		flex-shrink: 0;
		margin-right: 0.12rem;
		margin-top: 0.02rem;
	}

	.card-body {
		flex: 1;
		min-width: 0;
	}

	.card-name {
		font-size: $font-md;
		font-weight: 500;
		color: $text-dark;
		margin-bottom: 0.12rem;
		display: flex;
		align-items: center;
		.name{
			.t1{
				color: #333333;
				font-weight: bold;
			}
			.t2{
				background: #FFEDED;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #FF4747;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
			.t3{
				background: #EDF6FF;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #0096FF;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
		}
		.copy{
			span{
				font-size: 14px;
				color: #0096FF;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.del{
			margin-left: 16px;
			span{
				font-size: 14px;
				color: #FC3C3C;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.card-phone {
			margin-left: 0.20rem;
			font-weight: 400;
		}
	}

	.card-contact {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.08rem;

		span + span {
			margin-left: 0.16rem;
		}
	}

	.card-sub {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.06rem;
	}

	.card-addr {
		font-size: $font-sm;
		color: $text-gray;
		word-break: break-all;

		.addr-blue {
			color: $primary;
			margin-right: 0.06rem;
		}

		.addr-gray {
			color: $text-gray;
		}
	}
}
.info-card-a{
	transition:  0.25s ;
	span,div{
		color: #fff!important;
	}
	background: #0096FF;
}
.shaixuanFrom{
	margin-bottom: 12px;
	.iptBox{
		width: 445px;
		height: 50px;
		border-radius: 8px;
		background: #F9F9F9;
		padding: 0 20px;
		display: flex;
		align-items: center;
		::v-deep .el-input {
			width: 400px;
			height: 100%;
			border: none;
			padding-left: 16px;
		}
		::v-deep .el-input__inner {
			text-align: left;
			width: 100%;
			height: 100%;
			line-height: 0.78rem;
			background: transparent;
			border: none;
			font-size: 16px;
			padding: 0;
			&::placeholder {
				color: #A8A8A8;
			}
			&:focus {
				border-color: transparent;
				box-shadow: none;
			}
		}
	}
}
/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-top: 4px;
	margin-top: 32px;
}


/* 返回按钮 */
.btn-cancel {
	width: 184px;
	height: 60px;
	background: #E9F6FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}


/* 确认修改按钮 */
.btn-confirm {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}

/* ===================================================================
   删除确认弹窗
   =================================================================== */
.del-dialog-header {
	// height: 50px;
	display: flex;
	align-items: center;
	padding: 0 20px;
	// background: pink;
	// background: #f1f6fc;
}
.del-dialog-title {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin: 0;
}
.del-dialog-body {
	// padding: 20px 24px 10px;
	text-align: center;
}
.del-dialog-text {
	font-size: 16px;
	color: #333;
	margin: 0;
	line-height: 1.6;
}
.del-dialog-footer {
	display: flex;
	justify-content: center;
	padding: 10px 24px 24px;
	padding-bottom: 12px;
}
.del-btn {
	width: 120px;
	height: 42px;
	border-radius: 8px;
	text-align: center;
	line-height: 42px;
	font-size: 15px;
	cursor: pointer;
	transition: background 0.3s, opacity 0.3s;
}
.del-btn-cancel {
	background: #E9F6FF;
	color: #0096FF;
	margin-right: 16px;
	&:hover { background: #D6EDFF; }
}
.del-btn-confirm {
	background: #FC3C3C;
	color: #fff;
	&:hover { background: #FF5A5A; }
}
</style>